import { GroupedSouthOfFranceTreatments } from "./types";

export const southOfFranceTreatments: GroupedSouthOfFranceTreatments[] = [
  {
    name: "Massage",
    treatments: [
      {
        name: "Bespoke Massage 60 mins",
        id: "_bespoke_massage_60_mins",
        price: 181.2,
        description: "",
      },
      {
        name: "Bespoke Massage 90 mins",
        id: "_bespoke_massage_90_mins",
        price: 265.95,
        description: "",
      },
      {
        name: "Deep Tissue Massage 60 mins",
        id: "_deep_tissue_massage_60_mins",
        price: 189.67,
        description: "",
      },
      {
        name: "Deep Tissue Massage 90 mins",
        id: "_deep_tissue_massage_90_mins",
        price: 274.43,
        description: "",
      },
      {
        name: "Sports Massage 60 mins",
        id: "_sports_massage_60_mins",
        price: 189.67,
        description: "",
      },
      {
        name: "Sports Massage 90 mins",
        id: "_sports_massage_90_mins",
        price: 274.43,
        description: "",
      },
      {
        name: "Pregnancy Massage 60 mins",
        id: "_pregnancy_massage_60_mins",
        price: 181.2,
        description: "",
      },
      {
        name: "Pregnancy Massage 90 mins",
        id: "_pregnancy_massage_90_mins",
        price: 265.95,
        description: "",
      },
      {
        name: "Brazilian Lymphatic Drainage Massage 60 mins",
        id: "_brazilian_lymphatic_drainage_massage_60_mins",
        price: 189.67,
        description: "",
      },
      {
        name: "Brazilian Lymphatic Drainage Massage 90 mins",
        id: "_brazilian_lymphatic_drainage_massage_90_mins",
        price: 274.43,
        description: "",
      },
      {
        name: "Manual Lymphatic Drainage Massage 60 mins",
        id: "_manual_lymphatic_drainage_massage_60_mins",
        price: 189.67,
        description: "",
      },
      {
        name: "Manual Lymphatic Drainage Massage 90 mins",
        id: "_manual_lymphatic_drainage_massage_90_mins",
        price: 274.43,
        description: "",
      },
      {
        name: "Thai Massage 60 mins",
        id: "_thai_massage_60_mins",
        price: 181.2,
        description: "",
      },
      {
        name: "Thai Massage 90 mins",
        id: "_thai_massage_90_mins",
        price: 265.95,
        description: "",
      },
      {
        name: "Acupuncture 60 mins",
        id: "_acupuncture_60_mins",
        price: 189.67,
        description: "",
      },
      {
        name: "Acupuncture 90 mins",
        id: "_acupuncture_90_mins",
        price: 274.43,
        description: "",
      },
      {
        name: "Bespoke Facial Classic 60 Mins",
        id: "bespoke_facial_classic__60_minutes",
        price: 181.2,
        description: "",
      },
      {
        name: "Bespoke Facial Classic 90 Mins",
        id: "bespoke_facial_classic__90_minutes",
        price: 265.95,
        description: "",
      },
      {
        name: "Reiki",
        id: "reiki",
        price: 232.05,
        description: "",
      },
      {
        name: "Yoga",
        id: "yoga",
        price: 181.2,
        description: "",
      },
      {
        name: "Personal Training",
        id: "personal_training",
        price: 181.2,
        description: "",
      },
      {
        name: "Pilates",
        id: "pilates",
        price: 181.2,
        description: "",
      },
    ],
  },
  {
    name: "Nails",
    treatments: [
      {
        name: "Classic Manicure",
        id: "_classic_manicure",
        price: 123.34,
        description: "",
      },
      {
        name: "Classic Pedicure",
        id: "_classic_pedicure",
        price: 138.82,
        description: "",
      },
      {
        name: "Classic Manicure and Pedicure",
        id: "_classic_mani_and_pedi",
        price: 232.05,
        description: "",
      },
      {
        name: "Semipermanent Manicure",
        id: "__semipermanent_manicure",
        price: 147.29,
        description: "",
      },
      {
        name: "Semipermanent Pedicure",
        id: "_semipermanent_pedicure",
        price: 160.01,
        description: "",
      },
      {
        name: "Semipermanent Manicure & Pedicure",
        id: "_semipermanent_mani_pedi",
        price: 274.43,
        description: "",
      },
      {
        name: "Gel Manicure",
        id: "_gel_manicure",
        price: 181.2,
        description: "",
      },
      {
        name: "Gel Pedicure",
        id: "_gel_pedicure",
        price: 193.91,
        description: "",
      },
      {
        name: "Gel Manicure & Pedicure",
        id: "_gel_mani_and_pedi",
        price: 342.23,
        description: "",
      },
      {
        name: "Gel Extensions Infills",
        id: "_gel_extentions_infills",
        price: 181.2,
        description: "",
      },
      {
        name: "Gel Removal",
        id: "_gel_removal",
        price: 33.55,
        description: "",
      },
    ],
  },
  {
    name: "Hair",
    treatments: [
      {
        name: "Bespoke Blowdry Short",
        id: "_bespoke_blowdry_short",
        price: 181.2,
        description: "",
      },
      {
        name: "Bespoke Blowdry Long",
        id: "_bespoke_blowdry_long",
        price: 236.29,
        description: "",
      },
      {
        name: "Bespoke Blowdry Extra Thick",
        id: "bespoke_blowdry_extra_thick",
        price: 291.38,
        description: "",
      },
      {
        name: "Styling (updo, braids)",
        id: "styling_updo_braids",
        price: 236.29,
        description: "",
      },
      {
        name: "Women's Cut and Blowdry",
        id: "_cut_and_blowdry",
        price: 333.76,
        description: "",
      },
      {
        name: "Women's Cut (Blowdry not included)",
        id: "womens_cut_blowdry_not_included",
        price: 181.2,
        description: "",
      },
      {
        name: "Men's Cut",
        id: "_mens_cut",
        price: 124.24,
        description: "",
      },
    ],
  },
  {
    name: "Makeup and Eyes",
    treatments: [
      {
        name: "Bespoke Makeup",
        id: "bespoke_makeup",
        price: 223.57,
        description: "",
      },
      {
        name: "Full Set Classic Lash Extensions",
        id: "full_set_classic_lash_extensions",
        price: 237.98,
        description: "",
      },
      {
        name: "Classic Lash Extension Infills",
        id: "classic_lash_extension_infills",
        price: 181.2,
        description: "",
      },
      {
        name: "Full Set Russian Lash Extensions",
        id: "full_set_russian_lash_extensions",
        price: 350.71,
        description: "",
      },
      {
        name: "Russian Lash Extension Infills",
        id: "russian_lash_extension_infills",
        price: 237.98,
        description: "",
      },
      {
        name: "Lash Extensions Removal",
        id: "lash_extensions_removal",
        price: 56.23,
        description: "",
      },
      {
        name: "Lash Lift & Tint",
        id: "lash_lift__tint",
        price: 125.26,
        description: "",
      },
      {
        name: "Brow Lamination",
        id: "brow_lamination",
        price: 123.34,
        description: "",
      },
    ],
  },
  {
    name: "Waxing",
    treatments: [
      {
        name: "Full Leg Wax",
        id: "full_leg_wax",
        price: 86.15,
        description: "",
      },
      {
        name: "Half Leg Wax",
        id: "half_leg_wax",
        price: 68.02,
        description: "",
      },
      {
        name: "Underarms Wax",
        id: "underarms_wax",
        price: 47.16,
        description: "",
      },
      {
        name: "Hollywood/Brazilian Wax",
        id: "hollywoodbrazilian_wax",
        price: 78.9,
        description: "",
      },
      {
        name: "Arms Wax",
        id: "arms_wax",
        price: 56.23,
        description: "",
      },
      {
        name: "Back Wax",
        id: "back_wax",
        price: 75.24,
        description: "",
      },
      {
        name: "Upper Lip Wax",
        id: "upper_lip_wax",
        price: 38.09,
        description: "",
      },
      {
        name: "Brow Wax",
        id: "brow_wax",
        price: 51.69,
        description: "",
      },
    ],
  },
  {
    name: "Bridal",
    treatments: [
      {
        name: "Wedding Hair Trial",
        id: "wedding_hair_trial",
        description: "",
      },
      {
        name: "Wedding Hair",
        id: "wedding_hair",
        description: "",
      },
      {
        name: "Wedding Makeup Trial",
        id: "wedding_makeup_trial",
        description: "",
      },
      {
        name: "Wedding Makeup",
        id: "wedding_makeup",
        description: "",
      },
      {
        name: "Wedding Hair and Makeup Trial",
        id: "wedding_hair_and_makeup_trial",
        description: "",
      },
      {
        name: "Wedding Hair and Makeup",
        id: "wedding_hair_and_makeup",
        description: "",
      },
    ],
  },
];
